import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'app/com/ibm/tw/commons/mvc/base.component';
import { TxnService } from 'app/services/txn.service';
import { CommandButtonModule } from 'ui-components/button';
import { EventData } from 'ui-components/common';
import { MessagesModule } from 'ui-components/messages';
import { PopupModule } from 'ui-components/popup';
import { SoftTokenTxVerifyPopupViewForm } from './softtoken.tx.verify.popup.viewfrom';

@Component({
    standalone: true,
    selector: 'softtoken-tx-verify-popup',
    templateUrl: 'softtoken.tx.verify.popup.component.html',
    imports: [
        CommonModule,
        PopupModule,
        CommandButtonModule,
        MessagesModule
    ]
})
export class SoftTokenTxVerifyPopupComponent extends BaseComponent {

    @Input() display: boolean = false;

    @Input() viewForm: SoftTokenTxVerifyPopupViewForm;

    @Output() closeCallback = new EventEmitter();

    labelLeft: string;

    labelRight: string;

    /** 建構子 */
    constructor(public txnService: TxnService) {
        super(txnService);
    }

    onClose(event: EventData) {
        this.closeCallback.emit();
    }

    onShow() {
        if (this.viewForm.txFlag) {
            this.viewForm.title = this.transform('SoftToken 交易驗證', 'common00012500', null);
            this.labelLeft = this.transform('交易驗證推播已發送至您註冊SoftToken的裝置', 'common00020000', null);
            this.labelRight = this.transform('，請於該裝置進行驗證。', 'common00020002', null);
        } else {
            this.viewForm.title = this.transform('SoftToken 登入驗證', 'common00000693', null);
            this.labelLeft = this.transform('登入驗證推播已發送至您註冊SoftToken的裝置', 'common00020001', null);
            this.labelRight = this.transform('，請於該裝置進行驗證。', 'common00020004', null);
        }
    }

    onHide(event: EventData) {
        this.closeCallback.emit();
    }

}
